module.exports = __webpack_public_path__ + "img/recration.f97c2c0f.jpg";